import { call, put, select, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import Requester from "common/network/http/Request";
import EstimateActions, { EstimateRequestTypes } from "reducers/EstimateRedux";
import { FarmSelectors } from "reducers/FarmRedux";
import endpoints from "configs/endpoints";
import { history } from "store";
import { CreateFarmInput } from "schemas/SharedSchemas";

function* handleEstimateRequest(action) {
  const { data } = action;
  const farm = yield select(FarmSelectors.farm);
  const landValues = yield select(FarmSelectors.landValues);
  const farmClean = CreateFarmInput.clean(farm);
  const isSupportedState = yield select(FarmSelectors.isSupportedState);

  const input = {
    farm: {
      ...farmClean,
      cityId: farm.cityId,
    },
    estimateRequest: landValues,
    isSupportedState,
    selectedSoilIndex: parseFloat(data.average_estimate_index),
    selectedIndexType: data.average_estimate_type,
    selectedPrice: parseFloat(data.lease_price),
    user: {
      userType: data.user_type,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      phone: data.phone,
    },
  };

  try {
    const result = yield call(Requester.post.bind(Requester), endpoints.estimate.create, input);

    if (!get(result, "data.error")) {
      yield call(history.push, `/cashrent-estimate/${result.id}`);
      yield put(EstimateActions.estimateRequestSuccess());
    } else {
      yield put(EstimateActions.estimateRequestFailure());
    }
  } catch (err) {
    yield put(EstimateActions.estimateRequestFailure());
  }
}

export default function* () {
  return [
    yield takeLatest(EstimateRequestTypes.SUBMIT_REQUEST, handleEstimateRequest),
  ];
}
